import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import './index.css'
import favicon from '../images/favicon.ico'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Free Beer Boards"
      meta={[
        { name: 'description', content: 'Digital beer boards. Free forever. Unlimited locations.' },
        { name: 'keywords', content: 'digital beer boards, digital signage, beer signage, beer boards' },
      ]}>
    <link rel="shortcut icon" href={favicon} />
    </Helmet>
    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js